import { Box, useTheme } from "@mui/material";

import { TemplateList, WsTemplateExtended } from "@/components/Templates/templates";
import ListTemplates from "./ListTemplates.tsx";
export default function LeftPanel({
  templates,
  setActiveTemplate,
  activeId,
  additionalButtons,
}: {
  templates: TemplateList;
  setActiveTemplate: (value: WsTemplateExtended) => void;
  activeId: string | null;
  additionalButtons: boolean;
}) {
  const theme = useTheme();

  return (
    <Box sx={{ p: 0, pr: 0.5 }}>
      {templates?.myTemplates?.length > 0 && (
        <Box sx={{ mb: 1 }}>
          <Box sx={{ borderBottom: `solid 1px ${theme.palette.info.main}`, p: 1, fontWeight: "bold", mb: 1 }}>
            My Templates
          </Box>
          <Box sx={{ p: 0.5 }}>
            <ListTemplates
              showAuthor={false}
              activeId={activeId}
              setActiveTemplate={setActiveTemplate}
              templates={templates.myTemplates}
              additionalButtons={additionalButtons}
            />
          </Box>
        </Box>
      )}
      {templates?.notMyTemplates?.length > 0 && (
        <Box>
          <Box sx={{ borderBottom: `solid 1px ${theme.palette.info.main}`, p: 1, fontWeight: "bold", mb: 1 }}>
            Other Templates
          </Box>
          <Box sx={{ p: 0.5 }}>
            <ListTemplates
              showAuthor={true}
              activeId={activeId}
              setActiveTemplate={setActiveTemplate}
              templates={templates.notMyTemplates}
              additionalButtons={additionalButtons}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
